export const getAWSelectStyles = (disabled: boolean, dark: boolean) => ({
  control: (provided: any, state: any) => ({
    ...provided,
    minHeight: '37.6px',
    height: '37.6px',
    borderWidth: 0.8,
    borderRadius: '0.375rem',
    backgroundColor: disabled ? 'var(--bs-secondary-bg)' : 'var(--bs-body-bg)',
    borderColor: disabled ? 'transparent' : 'var(--bs-border-color)',
    boxShadow: state.menuIsOpen
      ? '0 0 1px 1.5px var(--accent-color)'
      : 'none',
    opacity: disabled ? 0.9 : 1,
    cursor: disabled ? 'not-allowed' : 'default',
  }),

  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--accent-color)'
      : state.isFocused
      ? 'rgba(24,218,173,.1)'
      : 'transparent',
    color: state.isSelected 
      ? 'white'  // Force white text for selected items
      : dark ? 'white' : 'black',
    padding: '.375rem',
  }),

  menu: (provided: any) => ({
    ...provided,
    backgroundColor: dark ? '#162637' : 'white',
    zIndex: 10,  // Ensure it appears above other elements
  }),

  input: (provided: any) => ({
    ...provided,
    color: dark ? 'white' : 'black',
  }),
  
  singleValue: (provided: any) => ({
    ...provided,
    color: dark ? 'white' : 'black',
  }),

  placeholder: (provided: any) => ({
    ...provided,
    color: dark ? '#aaa' : '#777',
  }),

  indicatorSeparator: (provided: any) => ({
    ...provided,
    backgroundColor: dark ? '#444' : '#ddd',
  }),

  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: dark ? '#aaa' : '#777',
    ':hover': {
      color: dark ? 'white' : 'black',
    },
  }),

  multiValue: (provided: any) => ({
    ...provided,
    backgroundColor: dark ? '#2d3e50' : '#f0f0f0',
    borderRadius: '4px',
  }),
  
  multiValueLabel: (provided: any) => ({
    ...provided,
    color: dark ? 'white' : 'black',
    fontSize: '0.875rem',
  }),
  
  multiValueRemove: (provided: any) => ({
    ...provided,
    color: dark ? '#aaa' : '#333',
    ':hover': {
      backgroundColor: dark ? '#3f5161' : '#ccc',
      color: dark ? 'white' : 'black',
    },
  }),
});